/**
 * Resolve a display name from profile/auth fields (never returns generic "Player").
 */
export function resolveDisplayName (
  { name, email, displayName }: { name?: any; email?: any; displayName?: any } = {}
) {
  const fromName = String(name || '').trim()
  if (fromName) return fromName

  const fromDisplayName = String(displayName || '').trim()
  if (fromDisplayName) return fromDisplayName

  const fromEmail = String(email || '').trim()
  if (fromEmail.includes('@')) {
    const local = fromEmail.split('@')[0].trim()
    if (local) return local
  }

  return ''
}
